import React from "react";
import { CpCheckboxGroup } from "@components";
import {
  useController,
  Control,
  RegisterOptions,
  UseControllerProps,
} from "react-hook-form";
import { CpCheckboxGroupItem } from "../cp-checkbox-group-item";
import { CpCheckboxGroupProps } from "../cp-checkbox-group";

type CpCheckboxGroupFieldProps = Omit<
  CpCheckboxGroupProps,
  "value" | "onChange" | "onBlur"
> & {
  control: Control<any>;
  controllerOptions?: Omit<UseControllerProps, "name" | "control" | "rules">;
  fieldName: string;
  rules?: RegisterOptions;
};

type CpCheckboxGroupFieldComponent = React.FC<CpCheckboxGroupFieldProps> & {
  Item: typeof CpCheckboxGroupItem;
};

export const CpCheckboxGroupField: CpCheckboxGroupFieldComponent = (
  props: CpCheckboxGroupFieldProps,
) => {
  const { fieldName, control, controllerOptions, rules, ...cpToggleProps } =
    props;
  const {
    field: { value, onBlur, onChange },
  } = useController({ name: fieldName, control, rules, ...controllerOptions });

  return (
    <CpCheckboxGroup
      {...cpToggleProps}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};

CpCheckboxGroupField.Item = CpCheckboxGroup.Item;
